import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import { SliderNumberInput } from '@components/SliderNumberInput'

import {
  TIME_LINE_OBJECT_X_CELL_MAX_HEIGHT,
  TIME_LINE_OBJECT_X_CELL_MAX_WIDTH,
  TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT,
  TIME_LINE_OBJECT_X_CELL_MIN_WIDTH,
  TIME_LINE_SLIDER_STEP,
} from '@constants'

type CellSizeSettingsProps = {
  minWidth: number
  minHeight: number
  onMinWidthChange: (value: number) => void
  onMinHeightChange: (value: number) => void
}

export const CellSizeSettings: React.FC<CellSizeSettingsProps> = ({
  minWidth,
  minHeight,
  onMinWidthChange,
  onMinHeightChange,
}) => {
  const { t } = useTranslation()

  const handleMinWidthSliderChange = (_event: Event, newValue: number | number[]) => {
    const value = Array.isArray(newValue) ? newValue[0] : newValue
    onMinWidthChange(value)
  }

  const handleMinWidthInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onMinWidthChange(Number(event.target.value))
  }

  const handleMinWidthInputBlur = () => {
    if (isNaN(minWidth) || minWidth < TIME_LINE_OBJECT_X_CELL_MIN_WIDTH) {
      onMinWidthChange(TIME_LINE_OBJECT_X_CELL_MIN_WIDTH)

      return
    }
    if (minWidth > TIME_LINE_OBJECT_X_CELL_MAX_WIDTH) {
      onMinWidthChange(TIME_LINE_OBJECT_X_CELL_MAX_WIDTH)
    }
  }

  const handleMinHeightSliderChange = (_event: Event, newValue: number | number[]) => {
    const value = Array.isArray(newValue) ? newValue[0] : newValue
    onMinHeightChange(value)
  }

  const handleMinHeightInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onMinHeightChange(Number(event.target.value))
  }

  const handleMinHeightInputBlur = () => {
    if (isNaN(minHeight) || minHeight < TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT) {
      onMinHeightChange(TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT)

      return
    }
    if (minHeight > TIME_LINE_OBJECT_X_CELL_MAX_HEIGHT) {
      onMinHeightChange(TIME_LINE_OBJECT_X_CELL_MAX_HEIGHT)
    }
  }

  return (
    <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, mb: 2 }}>
      <SliderNumberInput
        label={t('timeLinesCreateOrEdit.objectX.cell.minWidth')}
        maxValue={TIME_LINE_OBJECT_X_CELL_MAX_WIDTH}
        minValue={TIME_LINE_OBJECT_X_CELL_MIN_WIDTH}
        step={TIME_LINE_SLIDER_STEP}
        value={minWidth}
        onInputBlur={handleMinWidthInputBlur}
        onInputChange={handleMinWidthInputChange}
        onSliderChange={handleMinWidthSliderChange}
      />
      <SliderNumberInput
        label={t('timeLinesCreateOrEdit.objectX.cell.minHeight')}
        maxValue={TIME_LINE_OBJECT_X_CELL_MAX_HEIGHT}
        minValue={TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT}
        step={TIME_LINE_SLIDER_STEP}
        value={minHeight}
        onInputBlur={handleMinHeightInputBlur}
        onInputChange={handleMinHeightInputChange}
        onSliderChange={handleMinHeightSliderChange}
      />
    </Box>
  )
}
